import { IIconProps } from "./types"

export default function IconVec6(props: IIconProps) {
  const width = props.size || props.width || 46
  const height = props.size || props.height || 15
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 46 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3627 13.1346C21.9474 13.6569 26.5457 14.1621 31.3146 14.1621C36.0835 14.1621 41.0435 13.6569 43.5201 13.4009C46 13.1347 46 13.1346 46 13.1346V8.42731H17.3627V13.1346Z"
        fill="#3A3939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.9461 1.03779C39.2965 0.518921 34.6573 0 29.8201 0C24.9966 0 19.9753 0.518904 17.468 0.785164C14.9642 1.03777 14.9641 1.03779 14.9641 1.03779V5.86461H43.9461V1.03779Z"
        fill="#CCCCCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11.9346H7.68893V15L14.3135 10.9071L7.68893 6.80052V9.87961H0V11.9346Z"
        fill="#3A3939"
      />
    </svg>
  )
}
